import {DeviceType, DeviceTypeMetadata} from '@/model/network/device/DeviceType';

export enum ConnectionType {
  Ethernet = '802-3-ethernet',
  Vlan = 'vlan',
  Adsl = 'adsl',
  Gsm = 'gsm',
  Bridge = 'bridge',
  BridgeSlave = 'bridge-slave',
  Generic = 'generic',
  IpTunnel = 'ip-tunnel',
  Pppoe = 'pppoe',
  Tun = 'tun',
  Vpn = 'vpn',
  Wireguard = 'wireguard',
}

export const ConnectionTypeMetadata: Map<ConnectionType, any> = new Map([
  [ConnectionType.Ethernet, DeviceTypeMetadata.get(DeviceType.Ethernet)],
  [ConnectionType.Vlan, DeviceTypeMetadata.get(DeviceType.Vlan)],
  [ConnectionType.Adsl, DeviceTypeMetadata.get(DeviceType.Adsl)],
  [ConnectionType.Gsm, {
    label: 'GSM',
    icon: 'mdi-merge',
  }],
  [ConnectionType.Bridge, DeviceTypeMetadata.get(DeviceType.Bridge)],
  [ConnectionType.BridgeSlave, {
    label: 'Bridge slave',
    icon: 'mdi-merge',
  }],
  [ConnectionType.Generic, DeviceTypeMetadata.get(DeviceType.Generic)],
  [ConnectionType.IpTunnel, DeviceTypeMetadata.get(DeviceType.IpTunnel)],
  [ConnectionType.Pppoe, {
    label: 'PPPoE',
    icon: 'mdi-merge',
  }],
  [ConnectionType.Tun, DeviceTypeMetadata.get(DeviceType.Tun)],
  [ConnectionType.Vpn, {
    label: 'VPN',
    icon: 'mdi-vpn_lock',
    disabled: true,
  }],
  [ConnectionType.Wireguard, DeviceTypeMetadata.get(DeviceType.Wireguard)],
]);
